<template>
  <section class="p-6 flex flex-col gap-6">
    <!-- Breadcrumb -->
    <nav class="text-gray-600 text-sm">
      <span class="font-semibold cursor-pointer" @click="router.push('/')">Home</span>
      <span class="mx-2">/</span>
      <span class="cursor-pointer font-semibold" @click="router.push({ name: 'Articles' })">
        Articles
      </span>
      <span class="mx-2">/</span>
      <span class="text-gray-800 font-bold">Add Article</span>
    </nav>

    <h3 class="font-bold text-2xl">Add Article</h3>

    <form
      @submit.prevent="submitForm"
      class="bg-white shadow rounded-lg p-6 flex flex-col gap-6"
    >
      <!-- Titles -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Title (Arabic) *</label>
          <input
            v-model.trim="form.title_ar"
            class="border w-full rounded-md px-3 py-2"
            required
          />
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Title (English) *</label>
          <input
            v-model.trim="form.title_en"
            class="border w-full rounded-md px-3 py-2"
            required
          />
        </div>
      </div>

      <!-- Slug -->
      <div>
        <label class="block text-sm font-medium mb-1">Slug (optional)</label>
        <input v-model.trim="form.slug" class="border w-full rounded-md px-3 py-2" />
        <p class="text-xs text-gray-500 mt-1">
          If empty, the backend will generate it from the English title.
        </p>
      </div>

      <!-- Summaries -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Summary (Arabic)</label>
          <textarea
            v-model.trim="form.summary_ar"
            rows="3"
            class="border w-full rounded-md px-3 py-2"
          ></textarea>
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Summary (English)</label>
          <textarea
            v-model.trim="form.summary_en"
            rows="3"
            class="border w-full rounded-md px-3 py-2"
          ></textarea>
        </div>
      </div>

      <!-- Bodies -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Body (Arabic)</label>
          <textarea
            v-model.trim="form.body_ar"
            rows="7"
            class="border w-full rounded-md px-3 py-2"
          ></textarea>
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Body (English)</label>
          <textarea
            v-model.trim="form.body_en"
            rows="7"
            class="border w-full rounded-md px-3 py-2"
          ></textarea>
        </div>
      </div>

      <!-- Image Upload -->
      <div>
        <label class="block text-sm font-medium mb-1">Image</label>
        <input type="file" accept="image/*" @change="onFileChange" />
        <img
          v-if="preview"
          :src="preview"
          class="mt-2 w-24 h-24 object-cover rounded"
        />
      </div>

      <!-- Sort + Published -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Sort Order</label>
          <input
            type="number"
            v-model.number="form.sort_order"
            class="border w-full rounded-md px-3 py-2"
            min="0"
          />
        </div>

        <div class="flex items-center gap-2 mt-6">
          <input type="checkbox" v-model="form.is_published" />
          <label class="text-sm font-medium">Published</label>
        </div>
      </div>

      <button
        type="submit"
        class="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 self-end"
      >
        Save
      </button>
    </form>
  </section>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import apiClient from "@/apiClient";

const router = useRouter();

const imageFile = ref(null);   // ✅ مهم
const preview = ref(null);

const form = ref({
  title_ar: "",
  title_en: "",
  slug: "",
  summary_ar: "",
  summary_en: "",
  body_ar: "",
  body_en: "",
  sort_order: 0,
  is_published: true,
});

function onFileChange(e) {
  const file = e.target.files?.[0];
  if (!file) return;

  imageFile.value = file;
  preview.value = URL.createObjectURL(file);
}

async function submitForm() {
  const fd = new FormData();

  for (const key in form.value) {
    if (key === "is_published") {
      fd.append("is_published", form.value.is_published ? "1" : "0");
    } else {
      fd.append(key, form.value[key] ?? "");
    }
  }

  if (imageFile.value) {
    fd.append("image", imageFile.value);
  }

  try {
    await apiClient.post("/articles", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    alert("Article added successfully");
    router.push({ name: "Articles" });
  } catch (e) {
    console.error(e);
    alert("Failed to add article");
  }
}

</script>
